export enum FiItemUpdatedEventType {
    Feed = 0,
    Module = 1,
    Todo = 2,
}
